import { styled } from "@mui/material/styles";

// Components
import CurrencyInput from "react-currency-input-field";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Select, TextField, Typography } from "@mui/material";

// Themes
import theme from "~/components/Common/Theme";

const styledName = "LayoutForm";

const TextInputStyles = {
  fontSize: "1.6rem",
  paddingLeft: "14px",
  backgroundColor: "white",
  border: "none",
  height: "100%",
  borderRadius: "6px",

  "::before": {
    borderBottom: `none !important`,
  },
  "::after": {
    borderBottom: `none !important`,
  },
};

export const StyledFormItem = styled("div", { name: styledName })({
  "&": {
    width: "360px",
    height: "fit-content"
  },
});

export const StyledItemData = styled("div", { name: styledName })({
  "&": {
    display: "flex",
    height: "40px",
    borderBottom: `solid 1px ${theme.palette.grey[300]}`,
    alignItems: "center",
    ":hover": {
      borderBottomColor: theme.palette.primary.main,
    },
    ":focus-within": {
      borderBottomColor: theme.palette.primary.main,
    },
    transition: "border-bottom-color 0.3s linear",
  },
});

export const StyledFormInput = styled(TextField, { name: styledName })({
  "&": {
    ".MuiInputBase-root": {
      ...TextInputStyles,
    },
  },
});

export const StyledFormSelect = styled(Select, { name: styledName })({
  "&": {
    height: "100%",
    minWidth: "180px",
    width: "100%",
    border: "none",
    fontSize: "1.6rem",
    fieldset: {
      border: "none",
    },
  },
});

export const StyledCurrencyInput = styled(CurrencyInput, {
  name: styledName,
})({
  "&": {
    ...TextInputStyles,
    outline: "none",
    fontFamily: "'Outfit', sans-serif",
    fontSize: "2rem !important",
    color: theme.palette.primary.light,
    width: "100%",
  },
});

export const StyledDatePicker = styled(DatePicker, { name: styledName })({
  "&": {
    height: "100%",
    fieldset: {
      border: "none",
    },
    ".MuiInputBase-root": {
      ...TextInputStyles,
      paddingLeft: 0,
      fontSize: "1.6rem",
    },
    ".MuiInputBase-input": {
      padding: "0 14px",
    },
  },
});

export const StyledFormAction = styled("div", { name: styledName })({
  "&": {
    display: "flex",
    justifyContent: "space-around",
    marginTop: "20px",
    marginBottom: "-20px",
  },
});

export const StyledRequiredSign = styled("span", { name: styledName })({
  "&": {
    color: theme.palette.error.main,
    ":before": {
      content: "'*'",
    },
  },
});

export const StyledUnsaved = styled(Typography, { name: styledName })({
  "&": {
    marginTop: "20px",
    fontSize: "1.6rem",
    color: theme.palette.error.main,
    opacity: 0,
    maxHeight: 0,
    height: "auto",
    transform: "scaleY(0)",
    animation: `height-grow 0.3s ease-in forwards`,
  },
});
